/**
 * Path segments that Spring maps to Long must be non-empty digit-only strings.
 * Rejects undefined/null, "", literal "undefined", "ㅁㅁㅁ", "66741download", etc.
 */
export function isValidLongPathSegment(value: string | number | undefined | null): boolean {
  if (value === undefined || value === null) return false;
  const s = String(value).trim();
  return s.length > 0 && /^\d+$/.test(s);
}
